module.exports = __webpack_public_path__ + "img/logo_popol_vuh_border.4245a4af.png";